import { render, staticRenderFns } from "./form-block-create.vue?vue&type=template&id=19c3e5a5&"
import script from "./form-block-create.vue?vue&type=script&lang=js&"
export * from "./form-block-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports